module.exports = __webpack_public_path__ + "images/emoji/sunglasses.d7f1cceb1b8a715aa02e.png";